import { useEffect, useRef } from 'react'
import { Transition } from 'react-transition-group'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

import { useLayoutStore } from '@/store/layout'
import { useLoader } from '@/store/loader'

import AudioTrigger from './components/AudioTrigger'

const MixerController = () => {
  const loaded = useLoader((state) => state.loaded)
  const needsAudioTrigger = useLayoutStore((state) => state.needsAudioTrigger)
  const setLayoutState = useLayoutStore((state) => state.setState)
  const audioTrigger = useRef<HTMLButtonElement>(null!)
  const isPointerMoved = useRef(false)

  useEffect(() => {
    if (!loaded || ScrollTrigger.isTouch > 0) return

    const handlePointerMove = () => {
      if (!isPointerMoved.current) {
        isPointerMoved.current = true
        setLayoutState({ needsAudioTrigger: true })
      }
    }

    window.addEventListener('pointermove', handlePointerMove)

    return () => {
      window.removeEventListener('pointermove', handlePointerMove)
    }
  }, [loaded, setLayoutState])

  return (
    <Transition
      nodeRef={audioTrigger}
      in={needsAudioTrigger}
      timeout={{
        enter: 0,
        exit: 500
      }}
      unmountOnExit
    >
      {(state) => <AudioTrigger ref={audioTrigger} state={state} />}
    </Transition>
  )
}

export default MixerController
